module.exports = __webpack_public_path__ + "img/线对齐-角标.4b019d6e.svg";